import Card from "@/components/ui/Card";
import SectionHeader from "@/components/ui/SectionHeader";
import BulletList from "@/components/ui/BulletList";
import Container from "@/components/ui/Container";
import McpIconBadge from "./icons/McpIconBadge";
import keyAstromLogo from "@/assets/logos/keyastrom-logo.svg";

const darkText = "text-[16px] font-medium leading-[1.3] text-white";
const darkBullets = "text-[16px] font-medium leading-[1.3] text-white/90";

function Bridge({ axis, className = "" }) {
  const base =
    axis === "h"
      ? "absolute -left-5 top-1/2 h-1.5 w-5 -translate-y-1/2"
      : "absolute -top-5 h-5 w-1.5 -translate-x-1/2";
  return (
    <span
      aria-hidden="true"
      className={`${base} hidden bg-surface ${className}`}
    />
  );
}

function PhaseCard({ label, title, text, className = "", children }) {
  return (
    <Card variant="light" className={`gap-6 ${className}`}>
      {children}
      <span className="w-fit rounded-[5px] bg-white px-[21px] py-[10.5px] text-[14px] font-medium leading-none text-[#e85e57]">
        {label}
      </span>
      <h3 className="text-[21px] font-bold leading-none text-[#1c3564]">
        {title}
      </h3>
      <p className="text-[16px] font-medium leading-[1.3] text-[#1f1f1f]">
        {text}
      </p>
    </Card>
  );
}

export default function EvolutionSection() {
  return (
    <section>
      <Container>
        <SectionHeader
          label="Как меняется подход"
          heading="От наблюдения к управлению системой"
        />

        <div className="relative mt-10 md:mt-14 xl:mt-16">
          <span
            aria-hidden="true"
            className="absolute bottom-6 left-1/2 top-6 w-1.5 -translate-x-1/2 bg-surface md:hidden"
          />

          <div className="relative z-10 grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-4">
            {/* 1. Ранее / Мониторинг */}
            <PhaseCard
              label="Ранее"
              title="Мониторинг"
              text="Классический мониторинг показывает, что происходит"
              className="order-1 md:col-start-1 md:row-start-1 xl:col-start-1 xl:row-start-1"
            />

            {/* 2. Сейчас / Наблюдаемость */}
            <PhaseCard
              label="Сейчас"
              title="Наблюдаемость"
              text="Платформы наблюдаемости помогают понять, почему это происходит"
              className="order-2 md:col-start-1 md:row-start-2 xl:col-start-2 xl:row-start-1"
            >
              <Bridge axis="h" className="xl:block" />
              <Bridge axis="v" className="left-1/2 md:block xl:hidden" />
            </PhaseCard>

            {/* 4. Ключ-АСТРОМ (dark) */}
            <Card
              variant="dark"
              className="order-3 gap-4 md:col-start-2 md:row-start-2 xl:col-start-2 xl:row-start-2"
            >
              <Bridge axis="h" className="md:block xl:hidden" />
              <Bridge axis="v" className="left-1/2 xl:block" />
              <img
                src={keyAstromLogo}
                alt=""
                className="hidden size-[50px] self-start object-contain xl:block"
              />
              <h3 className="text-[20px] font-bold text-[#e85e57] min-[478px]:text-[21px]">
                Ключ-АСТРОМ
              </h3>
              <p className={darkText}>Ключ-АСТРОМ решает критические задачи</p>
              <BulletList
                className={darkBullets}
                items={[
                  "поиск аномалий",
                  "определение первопричин",
                  "анализ взаимосвязей сервисов",
                ]}
              />
            </Card>

            {/* 3. Следующий шаг / Аналитика с ИИ */}
            <PhaseCard
              label="Следующий шаг"
              title="Аналитика с ИИ"
              text="ИИ обрабатывает технические показатели и формирует выводы на языке бизнеса"
              className="order-4 md:col-start-1 md:row-start-3 xl:col-start-3 xl:row-start-1"
            >
              <Bridge axis="h" className="xl:block" />
              <Bridge axis="v" className="left-1/2 md:block xl:hidden" />
            </PhaseCard>

            {/* 5. Модуль MCP (dark, spans 2 cols on desktop) */}
            <Card
              variant="dark"
              className="order-5 gap-4 md:col-start-2 md:row-start-3 xl:col-start-3 xl:row-start-2 xl:col-span-2"
            >
              <Bridge axis="h" className="md:block xl:hidden" />
              <Bridge
                axis="v"
                className="left-[calc((100%-1.25rem)/4)] xl:block"
              />
              <McpIconBadge className="hidden xl:flex" />
              <h3 className="text-[20px] font-bold text-[#e85e57] min-[478px]:text-[21px]">
                Модуль MCP
              </h3>
              <p className={darkText}>
                Модуль MCP добавляет новый уровень к Ключ-АСТРОМ
              </p>
              <BulletList
                className={darkBullets}
                items={[
                  "ИИ выполняет системный анализ всей инфраструктуры",
                  "находит скрытые проблемы до их влияния на пользователей",
                  "предлагает действия для предотвращения сбоев",
                ]}
              />
            </Card>
          </div>
        </div>
      </Container>
    </section>
  );
}
